/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 4/20/15.
 */

//
// This is the original "Select Asset" modal. It's used for
// navigating and choosing files from Reach Engine virtual
// filesystem roots.
//

'use strict';

function SelectAssetModalController (
    _,
    VALID_FILE_EXTENSIONS,
    VirtualPathResourceFactory,
    ModalService,
    UtilsService
) {
    let setParentDirectory = () => {
        let paths = this.currentDirectory.path.split('/');
        this.parentDirectory = paths.slice(0, paths.length - 2).join('/') + '/';
    };

    let fileSystemSuccessHandler = (fileSystemDirectory) => {
        let filteredFiles = fileSystemDirectory.files.filter((file) => {
            // always include directories, and match all files by
            // default
            return _.get(this, 'currentFileTypes', new RegExp(``)).test(file.name) || file.directory;
        });

        let gridRows = fileSystemDirectory.roots.concat(filteredFiles);

        angular.forEach(gridRows, (row) => {
            row.name = row.alias || row.name;
        });

        this.gridOptions.data = gridRows;
        this.currentDirectory = fileSystemDirectory;
        this.builtPath = fileSystemDirectory.path;
        setParentDirectory();
    };

    let gridColumnDefinitions = [{
            field: 'name',
            width: '60%',
            displayName: 'Name',
            sort: {direction: 'asc', priority: 0},
            cellTemplate: 'components/visual/grid/base-tooltip-template.html'
        },
        {
            field: 'length',
            name: 'Type',
            width: '15%',
            displayName: '',
            enableColumnMenu: false,
            cellTemplate: 'package/editor/components/modals/selectAsset/folder-cell-template.html'
        },
        {
            field: 'lastModified',
            width: '25%',
            displayName: 'Modified',
            cellFilter: 'amDateFormat: \'MM/DD/YYYY\''
        }];

    this.builtPath = '';
    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableRowSelection: true,
        multiSelect: false,
        columnDefs: gridColumnDefinitions,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        onRegisterApi: (gridApi) => {
            this.gridApi = gridApi;
            this.gridApi.selection.on.rowSelectionChanged(null, (row) => {
                this.selectedRow = (row.isSelected) ? row.entity : null;
            });
        }
    };

    this.onRowDblClick = (row) => {
        this.loadFileSystemItem(row.entity);
    };

    this.loadSelectedItem = () => {
        this.loadFileSystemItem(this.selectedRow);
    };

    this.disableOKButton = () => {
        return !this.selectedRow || (this.selectedRow && (this.selectedRow.alias || this.selectedRow.directory));
    };

    const traverseToPath = (fileSystemItem) => {
        let path;
        if (fileSystemItem.path) {
            path = fileSystemItem.alias;
        } else {
            path = fileSystemItem.parent + fileSystemItem.name + '/';
        }
        VirtualPathResourceFactory.get({path: path}, fileSystemSuccessHandler);
    };

    const acceptItem = (item) => {
        let assetPath = (item) ? item.parent + item.name : this.selectedRow.parent + this.selectedRow.name;
        this.close({ $value: assetPath });
    };

    this.loadFileSystemItem = (fileSystemItem) => {
        if (fileSystemItem.path || fileSystemItem.directory) {
            traverseToPath(fileSystemItem);
        } else if (!this.validateFileFunc) {
            acceptItem(fileSystemItem);
        } else {
            this.loadingIndicator.show = true;
            this.validateFileFunc(fileSystemItem)
                .then((validationResults) => {
                    if (!_.isArray(validationResults)) {
                        validationResults = [validationResults];
                    }
                    let hasErrors = _.some(validationResults, (validationResult) => {
                        return !_.isEmpty(validationResult.errors);
                    });
                    let hasWarnings = _.some(validationResults, (validationResult) => {
                        return !_.isEmpty(validationResult.warnings);
                    });
                    if (hasErrors || hasWarnings) {
                        ModalService.showAssetValidationResultsModal(
                            validationResults, !hasErrors, () => acceptItem(fileSystemItem));

                    } else {
                        acceptItem(fileSystemItem);
                    }
                })
                .finally(() => {
                    this.loadingIndicator.show = false;
                });
        }
    };

    this.loadParentDirectory = () => {
        VirtualPathResourceFactory.get({path: this.parentDirectory}, fileSystemSuccessHandler);
    };

    this.refreshCurrentDirectory = () => {
        VirtualPathResourceFactory.get({path:this.currentDirectory.path}, fileSystemSuccessHandler);
    };

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        this.validateFileFunc = this.resolve.validateFileFunc;
        this.currentFileTypes = (typeof this.resolve.fileFilterType === 'string') ?
            UtilsService.buildFilters(VALID_FILE_EXTENSIONS[this.resolve.fileFilterType]) :
            UtilsService.buildFilters(this.resolve.fileFilterType);
        VirtualPathResourceFactory.get({}, fileSystemSuccessHandler);
    };
}

angular.module('prism-ui.package').component('selectAssetModal', {
    templateUrl: 'package/editor/components/modals/selectAsset/select-asset-modal-template.html',
    controller: SelectAssetModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&',
    }
});
